import merge from 'lodash.merge';

// convert dot notation string to nested object
export const createNestedObject = (fields: string, value: any): object => {
    const fieldsArr = fields.split('.');
    const reducer = (accum, item, index, array) => ({ [item]: index + 1 < array.length ? accum : value });
    return fieldsArr.reduceRight(reducer, {});
};

/**
 * Convert errors to the supported shape by final-form
 * e.g. { 'field.nestedField': 'error message' } => { field: { nestedField : 'error message' } }
 */
export const convertErrors = (errors: object | undefined) => {
    if (!errors) return;

    let result = {};
    for (const [key, value] of Object.entries(errors)) {
        merge(result, createNestedObject(key, value));
    }

    return result;
};
